import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const linkTemplatesNRO: NavigationRoutingObject = {
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("link-templates", "Email Link Templates"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "link-templates-description-nav",
      "Create link templates that append or prepend content to links in an email"
    ),
  icon: "nav-system-email-link-templates",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("link_templating");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/link_templates/:appGroupId",
};
